<template>
    <section v-if="currentSlide" class="h-screen bg-black text-white relative">
        <div class="h-full w-full absolute">
            <TransitionFadeBackground>
                <img v-if="slideCover" class="object-cover h-full w-full" :key="`slide-${currentSlideNumber}`" :src="slideCover" alt="">
                <div v-else class="h-full w-full" :style="`background-color: ${currentSlide.background_color}`"></div>
            </TransitionFadeBackground>
            <div class="bg-black opacity-30 w-full h-full absolute z-10 top-0 left-0"></div>
        </div>

        <div class="z-20 relative h-full w-full">
            <TransitionFadeVideo>
                <div :key="`slide-${currentSlideNumber}`" class="absolute top-[90px] xl:top-[110px] right-3 lg:right-12 w-[200px] lg:w-[360px]">
                    <div
                        v-if="currentSlide.video_path || currentSlide.thumbnail_path"
                        class="h-[160px] lg:h-[270px] rounded overflow-hidden"
                    >
                        <div class="relative h-full w-full">
                            <video v-if="currentSlide.video_path" class="h-full w-full object-cover" autoplay muted loop webkit-playsinline playsinline>
                                <source :src="currentSlide.video_path" type="video/mp4">
                                Your browser does not support the video tag.
                            </video>
                            <img v-else-if="currentSlide.thumbnail_path" class="h-full w-full object-cover" :src="currentSlide.thumbnail_path" alt="">
                        </div>
                    </div>

                    <div v-if="!isSlideQuote" class="lg:block pl-3 w-full mt-6 border-l border-white">
                        <p class="line-clamp-3 text-sm md:text-base" v-html="slideDescription"></p>

                        <a href="#" class="flex gap-1 items-center mt-6">
                            <router-link :to="learnMoreLink">{{ $t('learnMore') }}</router-link>
                            <span class="material-symbols-outlined text-base">arrow_right_alt</span>
                        </a>
                    </div>
                </div>
            </TransitionFadeVideo>

            <TransitionFadeTitle>
                <div v-if="isSlideQuote" class="absolute w-full top-0 left-0 h-full flex items-center justify-center px-3 lg:px-12">
                    <p v-html="currentSlide.quote" class="font-vectrex text-2xl lg:text-3xl text-left"></p>
                </div>
            </TransitionFadeTitle>


            <div class="absolute bottom-0 left-0 w-full">
                <div class="flex justify-between items-center mb-6 lg:mb-0 px-3 lg:px-12 lg:text-2xl">
                    <TransitionFadeTitle>
                        <div v-if="currentSlide.types" :key="`slide-${currentSlideNumber}`">
                            {{ currentSlide.types[0].name }}
                        </div>
                    </TransitionFadeTitle>

                    <div v-if="slides.length > 1" class="ml-auto">
                        <ol class="list-unstyled flex items-center justify-between gap-5">
                            <li
                                v-for="(slide, index) in slides"
                                :key="`slide-button-${index+1}`"
                                class="transition"
                                :class="{ 'opacity-40': currentSlideNumber !== index+1 }"
                                @click="setCurrentSlideNumber(index+1)"
                            >
                                <button>{{ `0${index+1}` }}</button>
                            </li>
                        </ol>
                    </div>
                </div>

                <TransitionFadeTitle>
                    <AtomTitleOpaque :key="`slide-${currentSlideNumber}`">
                        {{ slideTitle }}
                    </AtomTitleOpaque>
                </TransitionFadeTitle>

                <AtomCarouselLoadingBar
                    v-if="slides.length > 1"
                    :current-slide-number="currentSlideNumber"
                    :duration-css-string="durationCssString"
                    :timer-width-class="timerWidthClass"
                />
            </div>
        </div>
    </section>
</template>

<script>
import TransitionFadeBackground from "../../../transitions/home/TransitionFadeBackground.vue";
import TransitionFadeVideo from "../../../transitions/home/TransitionFadeVideo.vue";
import TransitionFadeTitle from "../../../transitions/home/TransitionFadeTitle.vue";
import carousel from "../../../mixins/carousel";
import AtomCarouselLoadingBar from "../../global/atoms/AtomCarouselLoadingBar.vue";
import { mapGetters, mapState } from "vuex";
import TransitionFade from "../../../transitions/TransitionFade.vue";
import AtomTitleOpaque from "../../global/atoms/AtomTitleOpaque.vue";
import Title from "../../legacy/PageDetail/Title.vue";

export default {
    name: 'OrganismHomeHero',
    components: {
        Title,
        AtomTitleOpaque,
        TransitionFade,
        AtomCarouselLoadingBar, TransitionFadeTitle, TransitionFadeVideo, TransitionFadeBackground},
    mixins: [carousel],
    computed: {
        ...mapState('home', {
            homeHeaderSection: state => state.homeHeaderSection
        }),
        ...mapGetters('home', {
            items: 'sortedItems'
        }),
        isSlideProject() {
            return this.currentSlide.model === 'project';
        },
        isSlideQuote() {
            return this.currentSlide.quote;
        },
        slideTitle() {
            if (this.isSlideProject) {
                return this.currentSlide.title ? this.currentSlide.title : ''
            } else {
                return this.currentSlide.name ? this.currentSlide.name : ''
            }
        },
        slideDescription() {
            if (this.isSlideProject) {
                return this.currentSlide.presentation ? this.currentSlide.presentation : ''
            } else {
                return this.currentSlide.description ? this.currentSlide.description : ''
            }
        },
        slideCover() {
            if (this.isSlideQuote) {
                return this.currentSlide.background_image_path;
            }
            if (this.currentSlide.public_cover_path) {
                return this.currentSlide.public_cover_path
            }
            return this.currentSlide.cover.cached_full_url ? this.currentSlide.cover.cached_full_url : this.currentSlide.cover.cached_url
        },

        slides() {
            const slides = this.items;
            if (this.homeHeaderSection.is_displayed_in_home) {
                slides.unshift({
                    quote: this.homeHeaderSection.quote,
                    background_image_path: this.homeHeaderSection.background_image_path,
                    background_color: this.homeHeaderSection.background_color,
                });
            }
            return slides;
        },

        learnMoreLink() {
            let routeName = this.currentSlide.model+'.view';
            return {name: routeName, params: {id: this.currentSlide.id, slug: this.currentSlide.slug}};
        }
    }
}
</script>
